/* ARCHIVO GENERADO AUTOMATICAMENTE - NO EDITAR A MANO.
   Fuente: src/sections/<tipo>.js (def.runtimeScript) y src/blocks/reveal-animation.js
   del repo shopify-builder. Regenerar con: npm run assets
   Cualquier cambio hecho aqui se pierde en la siguiente regeneracion. */
(function () {
  var els = document.querySelectorAll(".shp-reveal-item");
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) {
    els.forEach(function (el) { el.classList.add("is-visible"); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
})();

(function () {
  if (!window.matchMedia("(max-width: 768px)").matches) return;
  document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    img.loading = "eager";
  });
})();

(function () {
  var vids = document.querySelectorAll("video[data-shp-video]");
  if (!vids.length) return;

  // Sin autoplay: recibe src pero no se reproduce ni se pausa sola. Ver la cabecera del modulo.
  function esManual(v) { return v.hasAttribute("data-shp-manual"); }

  function activar(v) {
    // La comprobación que evita la descarga: si el breakpoint lo tiene oculto, ni src ni play.
    if (getComputedStyle(v).display === "none") { v.pause(); return; }
    if (!v.getAttribute("src")) v.setAttribute("src", v.getAttribute("data-shp-video"));
    if (esManual(v)) return;
    // play() devuelve una promesa que RECHAZA si el navegador bloquea la reproduccion; sin
    // capturarla queda un error no manejado en consola.
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Un video manual sin controles se reproduce al PULSARLO, y un segundo click lo pausa: es la unica
  // forma de arrancarlo. La descarga empieza justo ahi: hasta el click, preload="none" no ha pedido
  // ni un byte. Ver la cabecera del modulo sobre por que solo SIN controles.
  function alternar() {
    if (this.paused) {
      var p = this.play();
      if (p && p.catch) p.catch(function () {});
    } else {
      this.pause();
    }
  }
  vids.forEach(function (v) {
    if (esManual(v) && !v.hasAttribute("controls")) v.addEventListener("click", alternar);
  });

  if (!("IntersectionObserver" in window)) {
    vids.forEach(activar);
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) activar(entry.target);
      else if (!esManual(entry.target)) entry.target.pause();
    });
  }, { threshold: 0.15 });
  vids.forEach(function (v) { obs.observe(v); });
})();

(function () {
  // Guarda contra doble ejecución: si la plantilla tiene dos secciones "HTML Personalizado", cada
  // una emite su propia etiqueta de shp-core.js y sin esto se inicializaría todo por duplicado.
  if (window.__shpCore) return;
  window.__shpCore = 1;

  // Las URLs las inyecta la sección Liquid del tema (asset_url), porque solo ella conoce el id del
  // tema actual. Si falta el mapa, no hay nada que cargar y salimos en silencio.
  var urls = window.SHP_ASSETS || {};
  var probes = {
    "anchor-menu": ".shp-anchor-menu-wrapper",
    "bento": ".shp-bento-wrapper",
    "contenido": ".shp-contenido-wrapper",
    "countdown": ".shp-countdown-wrapper[data-shp-fin]",
    "feature1": ".shp-feature1-carousel",
    "feature2": ".shp-feature2-wrapper",
    "feature6": ".shp-feature6-wrapper",
    "feature7": ".shp-feature7-wrapper",
    "feature8": ".shp-feature8-wrapper",
    "hero2": ".shp-hero2-wrapper",
    "swiper": ".shp-swiper-wrapper",
    "visor360": ".shp-visor360-wrapper[data-shp-360]"
  };

  Object.keys(probes).forEach(function (slug) {
    var url = urls[slug];
    if (!url) return;
    if (!document.querySelector(probes[slug])) return;
    if (document.querySelector('script[data-shp="' + slug + '"]')) return;
    var s = document.createElement("script");
    s.src = url;
    // async=false preserva el orden de ejecución entre módulos inyectados dinámicamente; son
    // independientes entre sí, pero un orden estable hace reproducibles los tests.
    s.async = false;
    s.setAttribute("data-shp", slug);
    document.head.appendChild(s);
  });
})();
